/**
 * Environment Configuration & Validation
 * Ensures all required environment variables are set
 * and validates their format before app initialization
 */

const requiredEnvVars = [
  'REACT_APP_SUPABASE_URL',
  'REACT_APP_SUPABASE_ANON_KEY',
];

const validateEnvironment = () => {
  const missingVars = requiredEnvVars.filter(
    (varName) => !process.env[varName] || process.env[varName].trim() === ''
  );

  if (missingVars.length > 0) {
    const errorMsg = `Missing required environment variables:\n${missingVars.join('\n')}\n\nPlease copy .env.example to .env.local and fill in the values.`;
    
    if (process.env.NODE_ENV === 'development') {
      console.error('🔴 Environment Configuration Error:', errorMsg);
    } else {
      throw new Error('Environment configuration error');
    }
    
    return false;
  }

  // Validate Supabase URL format
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  if (!supabaseUrl.includes('supabase.co')) {
    console.warn('⚠️ Invalid Supabase URL format detected');
    return false;
  }

  // Validate Supabase Anon Key format (should be long string)
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  if (supabaseKey.length < 20) {
    console.warn('⚠️ Invalid Supabase Anon Key format');
    return false;
  }

  return true;
};

export const getEnvironmentConfig = () => {
  if (!validateEnvironment()) {
    return null;
  }

  return {
    supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
    supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
    apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
    maxRetries: parseInt(process.env.REACT_APP_MAX_RETRIES || '3', 10),
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
  };
};

export default getEnvironmentConfig;
